module.exports = __webpack_public_path__ + "static/media/insta.3534eaba.svg";